import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import withTheme from '@material-ui/core/styles/withTheme';

function Zone(props) {
    const pathColour1 = props.theme.palette.primary.main,
        pathColour2 = props.theme.palette.secondary.dark;

    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="ZoneIcon">
                <path
                    fill={pathColour2}
                    d="M39.81,26.37l7.08,14.55A.69.69,0,0,1,46.22,42H1.78a.69.69,0,0,1-.67-1.08L8.19,26.37A.82.82,0,0,1,8.86,26h6.08a.84.84,0,0,1,.56.26c.41.47.83.94,1.25,1.4s.8.88,1.19,1.33h-7.2a.84.84,0,0,0-.68.42L5.37,39H42.63l-4.69-9.64a.84.84,0,0,0-.68-.42H30l1.19-1.33c.42-.46.85-.93,1.26-1.4a.84.84,0,0,1,.56-.26h6.09a.82.82,0,0,1,.67.42Z" />
                
                <path
                    fill={pathColour1}
                    className="cls-2" d="M31.26,9a9.84,9.84,0,0,0-7.13-3h0a10.11,10.11,0,0,0-7.3,3.12,10.64,10.64,0,0,0-.13,14.71l6.21,7.42a1.31,1.31,0,0,0,1,.46h0a1.28,1.28,0,0,0,1-.46l6.31-7.51A10.64,10.64,0,0,0,31.26,9ZM24,21.57a5.7,5.7,0,1,1,5.7-5.7A5.7,5.7,0,0,1,24,21.57Z" />
            </g>
        </SvgIcon>
    );
}

export default withTheme(Zone);